





















































































































import { Component, Vue } from 'vue-property-decorator';
import { IRules } from '../../components/UI/Form/ValidationModule';
import { validateMin, validateRequired } from '../../components/UI/Form/Validations';

@Component
export default class Form extends Vue {
  public validForm = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public data: {[key: string]: any} = {
    number: '',
    name: '',
    verified: false,
    type: '',
    project: '',
    start_date: '',
    end_date: '',
    department: {
      name: '',
    },
    lines: [],
  };

  public types = [
    { label: 'Each', value: 'EACH' },
    { label: 'Litre', value: 'LITRE' },
  ];

  public projects = [
    { id: null, name: 'Project 0', active: false },
    { id: 1, name: 'Project 1', active: true },
    { id: 2, name: 'Project 2', active: true },
    { id: 3, name: 'Project 3', active: false },
    { id: 4, name: 'Project 4', active: false },
  ];

  public rules: IRules = {
    number: [ { validation: validateMin(3), message: 'Minimum 3 chars' } ],
    name: [ { validation: validateRequired(), message: 'Name is required' } ],
    type: [ { validation: validateRequired(), message: 'Type is required' } ],
    project: [
      { validation: validateRequired(), message: 'Project is required' },
      { validation: ({ objectValue }) => objectValue.active, message: 'test' },
    ],
    start_date: [
      { validation: validateRequired(), message: 'Start date is required' },
      {
        validation: ({ dataValue, formElements }) => {
          if (!formElements.end_date || !formElements.end_date.dataValue || !dataValue) return true;
          return formElements.end_date.dataValue > dataValue;
        },
        message: 'Start date must be before End date',
        triggerBy: [ 'end_date' ],
      },
    ],
    end_date: [ { validation: validateRequired(), message: 'End date is required' } ],
    department: {
      name: [
        { validation: validateRequired(), message: 'End date is required', triggerBy: [ 'project', 'start_date' ] },
      ],
    },
    lines: {
      name: [
        {
          validation: validateMin(3),
          message: 'Minimum 3 chars for description ',
          triggerBy: [ 'description' ],
        },
        {
          validation: ({ dataValue, formElements, uid }) => {
            const description = formElements.lines.description[uid as string];
            if (!description || !description.dataValue || !dataValue) return true;
            return description.dataValue > dataValue;
          },
          message: 'Name is grater then description alphabetically wise',
          triggerBy: [ ({ withSameUID }) => withSameUID('lines.description') ],
        },
      ],
      description: [],
    },
  };

  public withInput = false;
  public id = 0;

  public onChange() {
    this.data.project = Number(this.data.project) + 1;
  }

  public addInput() {
    this.$set(this.data, 'description', '');
    this.withInput = true;
  }

  public addLine() {
    const id = ++this.id;
    this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.data.lines.push({
        id,
        name: 1,
        description: 2,
      });
    });
  }

  public removeLastLine() {
    this.data.lines.pop();
  }
}
